import React from 'react';

interface IPageHeader {
  headerText: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const PageHeader: React.FC<IPageHeader> = ({ headerText, subtitle }) => (
  <div className="flex flex-col space-y-4">
    <div className="flex flex-col space-y-2">
      <div className="heading-3-bold text-gray-90" data-cy="page-header" data-testid="page-header">
        {headerText}
      </div>
      {subtitle && (
        <div className="body-regular text-gray-70" data-cy="page-header-subtitle" data-testid="page-header-subtitle">
          {subtitle}
        </div>
      )}
    </div>
  </div>
);
